module.exports = __webpack_public_path__ + "img/file-document-outline.3ad58ade.svg";